import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";
import { formatViews, getTypeLabel } from "@/utils/media";

interface MediaListItemProps {
  item: MediaItem;
  index?: number;
}

export default function MediaListItem({ item, index }: MediaListItemProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex gap-4 p-3 rounded-lg bg-background-100 border border-background-200 hover:border-primary-500/60 transition-colors cursor-pointer"
    >
      <div className="relative w-20 h-28 shrink-0 rounded-md overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 封面`}
          title={`${item.title} 在线观看`}
          className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        {typeof index === "number" && (
          <span className="absolute top-0 left-0 w-6 h-6 bg-primary-500 text-background-50 text-xs font-bold flex items-center justify-center rounded-br-md font-label">
            {index}
          </span>
        )}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <h3 className="text-sm md:text-base font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-400 transition-colors">
            {item.title}
          </h3>
          <span className="shrink-0 px-1.5 py-0.5 rounded bg-secondary-500/20 text-secondary-300 text-[11px] font-medium font-label">
            {getTypeLabel(item.type)}
          </span>
        </div>
        <p className="text-xs text-foreground-600 mt-1.5">
          {item.year} · {item.region} · {item.genres.join(" / ")}
        </p>
        <p className="text-xs text-foreground-600 mt-1 line-clamp-1">主演：{item.actors.join("、")}</p>
        <div className="flex items-center gap-4 mt-2 text-[11px] text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-[10px]" />
            {item.rating.toFixed(1)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line text-primary-500" />
            {formatViews(item.views)}
          </span>
          <span className="hidden sm:flex items-center gap-1">
            <i className="ri-refresh-line" />
            {item.updateStatus}
          </span>
        </div>
      </div>
      <div className="hidden sm:flex items-center">
        <span className="w-9 h-9 rounded-full bg-background-200 text-foreground-700 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
          <i className="ri-play-fill" />
        </span>
      </div>
    </Link>
  );
}